


















import { Component, Prop, InjectReactive, Vue, Watch } from 'vue-property-decorator'
import Auth from "../auth"
import Account from "../account"

@Component
export default class Login extends Vue {
    $log: any
    @Prop({default: '/'}) redirect!: string
    @InjectReactive() auths?: Auth[]
    @InjectReactive() account?: Account
    @Watch('account')
    checkLogin() {
        if (this.account) {
            var redirect = this.redirect
            if (redirect == this.$route.path) {
                redirect = '/'
            }
            this.$router.push({path: redirect})
        }
    }
}
